export const DEFAULT_TENANT = "ten_I9TW3ncG";
